import React from 'react';

import EmptyState from '~/components/core/EmptyState';
import RoundEmptyStateWrapper from '~/components/core/EmptyState/RoundEmptyStateWrapper';
import { PolicyIcon } from '~/components/icons';

export const PolicyEmptyState: React.FC = () => {
  return (
    <EmptyState
      title="No Policies Found"
      subtitle="Create your first policy to get started with the mock policy server."
      illustration={
        <RoundEmptyStateWrapper>
          <PolicyIcon />
        </RoundEmptyStateWrapper>
      }
    />
  );
};
